import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorMenuOverview = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M2.75 5c0-.966.784-1.75 1.75-1.75h5c.966 0 1.75.784 1.75 1.75v5a1.75 1.75 0 0 1-1.75 1.75h-5A1.75 1.75 0 0 1 2.75 10V5Zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25h-5ZM2.75 15c0-.966.784-1.75 1.75-1.75h5c.966 0 1.75.784 1.75 1.75v5a1.75 1.75 0 0 1-1.75 1.75h-5A1.75 1.75 0 0 1 2.75 20v-5Zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25h-5Zm10-1.5A1.75 1.75 0 0 0 12.75 15v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 21.25 20v-5a1.75 1.75 0 0 0-1.75-1.75h-5ZM14.25 15a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25h-5a.25.25 0 0 1-.25-.25v-5Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M15.763 3.177a1.75 1.75 0 0 1 2.474 0l2.829 2.828a1.75 1.75 0 0 1 0 2.475l-2.829 2.829a1.75 1.75 0 0 1-2.474 0L12.934 8.48a1.75 1.75 0 0 1 0-2.475l2.829-2.828Zm1.414 1.06a.25.25 0 0 0-.354 0l-2.828 2.829a.25.25 0 0 0 0 .353l2.828 2.829a.25.25 0 0 0 .354 0l2.828-2.829a.25.25 0 0 0 0-.353l-2.828-2.829Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorMenuOverview;
